import styled from 'styled-components';
import { ACCOUNTS } from 'src/utils/constants';
import AccountButton from './AccountButton';

const AccountList = () => {
  return (
    <StyledUl>
      {ACCOUNTS.map((item) => {
        return (
          <li key={item.id}>
            <AccountButton data={item} />
          </li>
        );
      })}
    </StyledUl>
  );
};

const StyledUl = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-family: var(--pretendard);
  font-size: 1.6rem;
  line-height: 2.2rem;
`;

export default AccountList;
